<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <template v-if="collectingInstitution">
      <collecting-institution-form
        :isLoading="isLoading"
        :collectingInstitution="collectingInstitution"
        :onSubmit="onSubmit">
      </collecting-institution-form>
    </template>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import CollectingInstitutionForm from './CollectingInstitutionForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { collectingInstitutionRegistry } = services;
const { collectingInstitutionService } = collectingInstitutionRegistry;

export default {
  name: 'CollectingInstitutionUpdate',
  components: {
    CollectingInstitutionForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Update Collecting Institution',
      enableBackButton: true,
    },
    collectingInstitution: null,
  }),
  async created() {
    const { id } = this.$route.params;
    const collectingInstitution = await collectingInstitutionService.getOne({ id });
    this.collectingInstitution = collectingInstitution;
  },
  methods: {
    async onSubmit(dataChange) {
      const data = Object.assign(this.collectingInstitution || {}, dataChange);
      this.isLoading = true;
      try {
        await collectingInstitutionService.update({ collectingInstitution: data });

        this.$snackbar.showOk({ text: 'Successfully updated Collecting Institution!' });

        this.$router.push({ name: 'collecting-institution.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
